/**
 * RBAC helpers from the auth store (interface / element / menu).
 */

import { useAuthStore } from '@/stores/authStore';

/** RBAC helpers (`canViewInterface` / element / menu) from the auth store. */
export const usePermissions = () => {
  const { canViewInterface, canEditInterface, canViewElement, canEditElement, canViewMenu } =
    useAuthStore();

  return {
    canViewInterface,
    canEditInterface,
    canViewElement,
    canEditElement,
    canViewMenu,
  };
};
